import { defineComponent as _defineComponent } from 'vue'
import { ref, watch, computed } from "vue";
  import Modal from "@/components/ui/Modal.vue";
  import { LotStatus } from "@/enums/LotStatus";
  import { getStatusText } from "@/v2/helpers/getStatusText";

  interface Props {
    isOpen: boolean;
    lotTitle: string;
    status?: string;
    existingBuyers?: {
      firstBuyer?: string;
      secondBuyer?: string;
    };
  }

  
export default /*@__PURE__*/_defineComponent({
  __name: 'SetHoldBuyersModal',
  props: {
    isOpen: { type: Boolean },
    lotTitle: {},
    status: { default: LotStatus.HOLD },
    existingBuyers: { default: undefined }
  },
  emits: ["close", "confirm"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

  const props = __props;
  const emit = __emit;

  const firstBuyer = ref("");
  const secondBuyer = ref("");

  const hasAnyBuyers = computed(
    () =>
      firstBuyer.value.trim().length > 0 || secondBuyer.value.trim().length > 0
  );

  const modalTitle = computed(() => {
    return `Put ${props.lotTitle} ${getStatusText(props.status)}`;
  });

  const modalDescription = computed(() => {
    return `Enter the buyer name(s) for this ${getStatusText(props.status, {
      form: "short",
    })}.`;
  });

  watch(
    () => props.isOpen,
    (isOpen) => {
      if (isOpen) {
        // Pre-populate with existing buyers if available, otherwise clear
        firstBuyer.value = props.existingBuyers?.firstBuyer || "";
        secondBuyer.value = props.existingBuyers?.secondBuyer || "";
      }
    }
  );

  const close = () => {
    emit("close");
  };

  const confirm = () => {
    emit("confirm", {
      firstBuyer: firstBuyer.value.trim() || undefined,
      secondBuyer: secondBuyer.value.trim() || undefined,
    });
    close();
  };

const __returned__ = { props, emit, firstBuyer, secondBuyer, hasAnyBuyers, modalTitle, modalDescription, close, confirm, ref, watch, computed, Modal, get LotStatus() { return LotStatus }, get getStatusText() { return getStatusText } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})